import { FC, Fragment } from 'react';

import { isEmpty, isNonNullish } from 'remeda';
import useSWR from 'swr';

import { CreateVideoButton } from './createVideoButton/CreateVideoButton';
import { DraggableVideoCards } from './draggableVideoCards/DraggableVideoCards';

import css from './VideoPage.module.css';

import { videoService } from 'v2/api/videoService';
import { EmptyPlaceholder } from 'v2/components/emptyPlaceholder/EmptyPlaceholder';
import { Loader } from 'v2/components/loader/Loader';
import { PageLayout } from 'v2/components/pageLayout/PageLayout';
import { PageTitle } from 'v2/components/pageLayout/pageTitle/PageTitle';

export const VideoPage: FC = () => {
  const { data, isLoading, mutate } = useSWR('getVideos', videoService.getVideos);

  return (
    <PageLayout className={css.videoPage} overflow="hidden">
      <PageTitle action={<CreateVideoButton onSuccess={mutate} />}>Video Settings</PageTitle>

      <div className={css.videoPageContent}>
        {isLoading ? (
          <Loader />
        ) : (
          isNonNullish(data) && (
            <Fragment>
              {isEmpty(data.result) ? (
                <EmptyPlaceholder />
              ) : (
                <DraggableVideoCards videos={data.result} onRevalidate={mutate} />
              )}
            </Fragment>
          )
        )}
      </div>
    </PageLayout>
  );
};
